import { FeatureFlagEnum } from "#root/config/enums/feature-flag.enum";
import { Injectable } from "@angular/core";
import { environment } from "environments/environment";

@Injectable({ providedIn: "root" })
export class FeatureFlagService {
  private readonly flags = new Map<FeatureFlagEnum, boolean>();

  constructor() {
    environment.appConfig.featureFlags.forEach(({ key, enabled }) => {
      this.flags.set(key, enabled);
    });
  }

  isEnabled(key: FeatureFlagEnum): boolean {
    return this.flags.get(key) ?? false;
  }
}
